module.exports = __webpack_public_path__ + "static/media/house.686433ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/house.svg
// module id = 282
// module chunks = 0